module.exports = __webpack_public_path__ + "img/image26.778bfd7e.jpg";